module.exports = __webpack_public_path__ + "img/loufeng_actived.2a41c3fc.png";